import React from 'react';
import { useEntitlements, canUseFeature } from '../../hooks/useEntitlements';
import { FeatureKey } from '../../types/entitlements';
interface GateProps {
  feature: FeatureKey;
  children: ReactNode;
  onPass?: () => void;
  onFail?: () => void;
  fallback?: ReactNode;
}
export function Gate({
  feature,
  children,
  onPass,
  onFail,
  fallback
}: GateProps) {
  const entitlements = useEntitlements();
  const hasAccess = canUseFeature(entitlements, feature);
  const handleClick = (e: React.MouseEvent) => {
    if (!hasAccess) {
      e.preventDefault();
      e.stopPropagation();
      onFail?.();
    } else {
      onPass?.();
    }
  };
  if (!hasAccess && fallback) {
    return <>{fallback}</>;
  }
  return <div onClick={handleClick} className={!hasAccess ? 'cursor-not-allowed' : ''} data-id="element-3530">
      {children}
    </div>;
}